import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/dataV.js'
import plugin from './plugins/index'
import './assets/font/iconfont.css'
import './assets/font/digitize_iconfont.css'
import './assets/css/reset.css'
import './plugins/echarts.js'
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

Vue.use(plugin)
Vue.config.productionTip = false

new Vue({
  router,
  store,

  render: h => h(App)
}).$mount('#app')
